<template>
  <router-view v-if="message"
               :message="message">
  </router-view>
</template>
<script>
import base64url from 'base64-url';
import mailgunService from '../../../../ml/services/mailgunService';

export default {
  data() {
    return {
      busy: false,
      message: null,
    }
  },
  computed: {
    messageID() {
      return parseInt(this.$route.params.messageID);
    }
  },
  created() {
    this.fetchData(this.messageID);
  },
  methods: {
    fetchData(messageID) {
      mailgunService.getMessage(messageID)
        .then(message => {
          this.message = message;
        })
        .catch(err => {

        })
        .finally(() => {
          this.busy = false;
        })
    }
  }
}
</script>
